import React from 'react';
import { useToast } from '../../contexts/ToastContext';
import { ToastMessage } from '../../types';
import { Icon, IconName } from '@/components/ui/Icon';

const ToastItem: React.FC<{ toast: ToastMessage; onDismiss: (id: string) => void }> = ({ toast, onDismiss }) => {
    const getStyles = () => {
        switch (toast.type) {
            case 'success': return 'bg-emerald-500/90 border-emerald-600 text-white shadow-[0_0_15px_rgba(16,185,129,0.3)]';
            case 'error': return 'bg-red-500/90 border-red-600 text-white shadow-[0_0_15px_rgba(239,68,68,0.3)]';
            case 'warning': return 'bg-amber-500/90 border-amber-600 text-white shadow-[0_0_15px_rgba(245,158,11,0.3)]';
            default: return 'bg-blue-500/90 border-blue-600 text-white shadow-[0_0_15px_rgba(59,130,246,0.3)]';
        }
    };

    const getIconName = (): IconName => {
        switch (toast.type) {
            case 'success': return 'check';
            case 'error': return 'x';
            case 'warning': return 'alert-triangle';
            default: return 'info';
        }
    };

    return (
        <div className={`mb-3 flex items-center w-full max-w-sm rounded-lg border p-4 shadow-lg backdrop-blur-sm transition-all animate-slideInLeft ${getStyles()}`}>
            <div className="mr-3 flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-white/20">
                <Icon name={getIconName()} size="sm" strokeWidth={2.5} />
            </div>
            <div className="flex-1 text-sm font-medium">{toast.message}</div>
            <button
                onClick={() => onDismiss(toast.id)}
                className="ml-3 inline-flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full text-white/80 hover:bg-white/20 hover:text-white transition-colors"
            >
                <Icon name="x" size="xs" strokeWidth={2.5} />
            </button>
        </div>
    );
};

const ToastContainer: React.FC = () => {
    const { toasts, removeToast } = useToast();

    return (
        // Top-right, above modal overlays (z-[9999]) and clear of the OmniAsk
        // button that owns the bottom-right corner.
        <div className="fixed top-20 right-6 z-[10000] flex flex-col items-end pointer-events-none">
            <div className="pointer-events-auto">
                {toasts.map(toast => (
                    <ToastItem key={toast.id} toast={toast} onDismiss={removeToast} />
                ))}
            </div>
        </div>
    );
};

export default ToastContainer;
